import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import _ from 'lodash'

// ------------------------------------
// Constants
// ------------------------------------
export const CRYPTO_PAY_ORDER_DETAILS = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    SUBMIT_AND_QUERY_RESULT_REQUEST: null,
    SUBMIT_AND_QUERY_RESULT_SUCCESS: null,
  },
  'CRYPTO_PAY_ORDER_DETAILS'
)

// ------------------------------------
// Actions
// ------------------------------------

export function init(data) {
  return (dispatch, getState) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        errControl: true,
        endpoint:
          'customerFrontend/cccashier/v1/unauth/getCashierSessionWebPageView',
        requestAction: CRYPTO_PAY_ORDER_DETAILS.INIT_REQUEST,
        successAction: CRYPTO_PAY_ORDER_DETAILS.INIT_SUCCESS,
        success: function(result) {
          if (getState().router.location.pathname === '/crypto-pay/order-details') {
            if (_.get(result, 'session.status') === 'WAITING_PAY') {
              setTimeout(() => {
                return dispatch(init(data))
              }, 5000)
            } else {
              window.location.href = `/crypto-pay/result?token=${data.token}`
            }
          }
        },
      })
    )
  }
}

export function submitAndQueryResult(data) {
  return (dispatch, getState) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'customerFrontend/cccashier/v1/unauth/selectPlatform',
        requestAction: CRYPTO_PAY_ORDER_DETAILS.SUBMIT_AND_QUERY_RESULT_REQUEST,
        successAction: CRYPTO_PAY_ORDER_DETAILS.SUBMIT_AND_QUERY_RESULT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CRYPTO_PAY_ORDER_DETAILS.INIT_REQUEST]: (state, action) => state,
  [CRYPTO_PAY_ORDER_DETAILS.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [CRYPTO_PAY_ORDER_DETAILS.SUBMIT_AND_QUERY_RESULT_REQUEST]: (state, action) =>
    state,
  [CRYPTO_PAY_ORDER_DETAILS.SUBMIT_AND_QUERY_RESULT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: true,
}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'cryptoPayOrderDetails',
    reducerMap: {
      cryptoPayOrderDetailsState: reducer,
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    // initialActions: [],
    finalActions: [],
  }
}
